import { render, staticRenderFns } from "./SessionReviewsButton.vue?vue&type=template&id=eff7a9fe"
import script from "./SessionReviewsButton.vue?vue&type=script&lang=js"
export * from "./SessionReviewsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports